import axios from "axios";
import { createTransactionID } from "../utils";

var counter = 0;
const win: any = window;
const reGenerateTokenUrl = '/mobilyTheme4/UtilityServlet?tk=dapicl';
const serverURL = window.location.origin.includes('localhost') ? "http://ssta004:8080" : window.location.origin;

let config = {
    api: {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Correlation-Id": createTransactionID(true)
        },
    },
};

export const api = axios.create({ ...config.api });
export const simpleApi = axios.create();

api.defaults.validateStatus = function () {
    return true;
};

api.interceptors.request.use(
    async (conf: any) => {
        console.log(win["cem_key"], 'cem')
        conf.baseURL = win["apigee_bm_base_url"];
        conf.headers['cem-key'] = win["cem_key"];
        conf.headers["X-Source-Channel"] = "PORTAL";
        conf.headers["X-Transaction-Id"] = createTransactionID();
        conf.headers["Authorization"] = `Bearer ${win['bmToken']}`;

        return conf;
    }, (err) => {
        console.log("error in getting ", err);
    }
);

api.interceptors.response.use(
    async (response: any) => {
        if (
            (response.data.code && response.data.code === "APIGEE-001") ||
            (response.data.code && response.data.code === "APIGEE-002")
        ) {
            counter++;
            const token = await reGenerateToken();
            const { config: oldRequest } = response;
            oldRequest.headers.Authorization = `Bearer ${token}`;
            if (counter < 2) return api.request({ ...oldRequest });
        }
        return response;
    }, async (error: any) => {
        if (!!win["errorPageURL"]) {
            document.location.href = win["errorPageURL"];
        }
        return error;
    }
);

function reGenerateToken() {
    return new Promise((resolve, reject) => {
        const url = `${serverURL}${reGenerateTokenUrl}`;

        fetch(url)
            .then((res) => res.text())
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

const sendOtp = (data: any) => {
    const baseUrl = win["apigee_bm_base_url"];
    const url = `${baseUrl}/cem/bff/otp/v1/send`;
    return api.post(url, data);
};

const resendOtp = (data: any) => {
    const baseUrl = win["apigee_bm_base_url"];
    const url = `${baseUrl}/cem/bff/otp/v1/resend`;
    return api.put(url, data);
};

const validateAuth = (data: any) => {
    const baseUrl = win["apigee_bm_base_url"];
    const url = `${baseUrl}/cem/bff/otp/v1/validate`;
    return api.put(url, data);
};

export { sendOtp, validateAuth, resendOtp };